// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"ea1cb494","955":"e9d4b794"}[chunkId] + ".chunk.css";
};